/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Manual_Therapy_TermsInputs */

const en_service_type_manual_therapy_terms = /** @type {(inputs: Service_Type_Manual_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manual therapist, mobilisation, back pain, spine, neck pain, headache, migraine`)
};

const pl_service_type_manual_therapy_terms = /** @type {(inputs: Service_Type_Manual_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terapeuta manualny, nastawianie, blokada, ból pleców, kręgosłup, ból karku, ból głowy, migrena`)
};

/**
* | output |
* | --- |
* | "manual therapist, mobilisation, back pain, spine, neck pain, headache, migraine" |
*
* @param {Service_Type_Manual_Therapy_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_manual_therapy_terms = /** @type {((inputs?: Service_Type_Manual_Therapy_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Manual_Therapy_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_manual_therapy_terms(inputs)
	return en_service_type_manual_therapy_terms(inputs)
});